import AtriumApi from "api";
import Loader from "components/loader/Loader";
import dayjs from "dayjs";
import React, { useEffect } from "react";

const History = ({ user }) => {
  const [loading, setLoading] = React.useState(true);

  const [services, setServices] = React.useState([]);

  useEffect(() => {
    setLoading(true);
    const fetchAllCampuses = async () => {
      try {
        const response = await AtriumApi.get(
          `/v2/logs/service?userId=${user?.id}`
        );

        if (response) {
          setServices(response?.data?.data?.data);
        }
      } catch (error) {
        console.log("An error occurred", error);
      } finally {
        setLoading(false);
      }
    };
    fetchAllCampuses();
  }, []);

  const today = dayjs().format("YYYY-MM-DD");

  return (
    <div className=" p-4 text-[#2F2F81] dark:text-white font-sans">
      <div className="grid grid-cols-2 font-medium text-xs border-b pb-2 uppercase text-[#B5B5C3]">
        <div>SERVICE</div>
        <div>DATE AND TIME</div>
      </div>
      {loading ? (
        <div className="flex items-center justify-center py-6">
          <Loader />
        </div>
      ) : services?.length > 0 ? (
        services?.map((service, index) => (
          <div key={index} className="grid grid-cols-2 py-4 border-b">
            <div>
              <div className="font-semibold text-sm capitalize">
                {service?.Service?.name}
              </div>
              <div className="text-sm text-[#9CA3AF]">
                {service?.Service?.type}
              </div>
            </div>
            <div className="text-sm">
              <div className="font-semibold">
                {dayjs(service?.Service?.date).format("MMM DD, YYYY")}
              </div>
              <div className="text-[#9CA3AF]">
                {dayjs(`${today} ${service?.Service?.startAt}`).format(
                  "hh:mm A"
                )}{" "}
                -{" "}
                {dayjs(`${today} ${service?.Service?.endAt}`).format("hh:mm A")}
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="py-6 text-center text-sm">
          No service history available.
        </div>
      )}
    </div>
  );
};

export default History;
